import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "passwordList" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }


import { useConfigSync } from '@/config/useConfig'

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordPoliciesList',
  props: ['isSymbolsPolicyMeet', 'isLengthPolicyMeet', 'isLowercasePolicyMeet', 'isRequireNumberPolicyMeet', 'isUppercasePolicyMeet'],
  setup(__props) {


const config = useConfigSync()
const requireLowercase = config.password_policy.require_lowercase
const requireNumbers = config.password_policy.require_numbers
const requireSymbols = config.password_policy.require_symbols
const requireUppercase = config.password_policy.require_uppercase
const minimumLength = config.password_policy.minimum_length
const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, "Password should contain:", -1)),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'grayout': !props.isLengthPolicyMeet })
        }, "At least ten characters.", 2)
      ]),
      (_unref(requireUppercase))
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'grayout': !props.isUppercasePolicyMeet })
            }, "At least one uppercase letter.", 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(requireLowercase))
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'grayout': !props.isLowercasePolicyMeet })
            }, "At least one lowercase letter.", 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(requireSymbols))
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'grayout': !props.isSymbolsPolicyMeet })
            }, "At least one special character ( ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` = + - ).", 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(requireNumbers))
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'grayout': !props.isRequireNumberPolicyMeet })
            }, "At least one number.", 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})